import { getDefaultTransition, rwd } from '@billy/design-system'
import { css } from '@emotion/core'

import { SIDE_NAVBAR_WIDTH } from '../../SideNavbar'

interface GetCommonVisibilityStylesArgs {
  visible?: boolean
  isMovedToRight?: boolean
}

export const getCommonVisibilityStyles = ({ visible, isMovedToRight }: GetCommonVisibilityStylesArgs) => css`
  opacity: ${visible ? 1 : 0};
  pointer-events: ${visible ? 'auto' : 'none'};
  margin-left: ${isMovedToRight ? `${SIDE_NAVBAR_WIDTH}` : 'initial'};

  ${getDefaultTransition('opacity')};

  ${rwd.greaterThan('xlarge')} {
    display: none;
  }
`
